import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const Heart = (props: IconProps) => (
  <Icon width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8611 0.75C18.3833 0.75 20.75 4.1025 20.75 7.23C20.75 13.5638 10.9278 18.75 10.75 18.75C10.5722 18.75 0.75 13.5638 0.75 7.23C0.75 4.1025 3.11667 0.75 6.63889 0.75C8.66111 0.75 9.98333 1.77375 10.75 2.67375C11.5167 1.77375 12.8389 0.75 14.8611 0.75Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
